module.exports = __webpack_public_path__ + "2e936eaad6ca65c00b9217e48a75d37c.png";